import React, { useState } from "react";
import classes from "../styles/style.module.css";
import Modal from "../../../assets/components/ModalComonent";
import { useNavigate } from "react-router";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";
import CustomButton from "../../../assets/components/CustomButton";
import CustomHint from "../../../assets/containers/CustomHint";

const SubmitReserveModal = ({ show, closeHandler, participant, data }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const confirmHandler = async () => {
    setLoading(true);
    try {
      await appApi
        .post(`/eventTicket/create`, {
          participants: participant,
          eventSectionId: data._id,
        })
        .then(({ data }) => {
          navigate(`/ticket/${data.ticket._id}`, { replace: true });
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const content = (
    <div className={classes.submitCountContent}>
      <h5 className="text-center">ثبت نهایی</h5>
      <CustomHint hint={"پس از ثبت نام امکان ویرایش وجود نخواهد داشت ."} />
      <p className="mt-3">
        آیا از رزرو سانس {data?.name ? data.name : "سانس مورد نظر"} اطمینان
        دارید ؟
      </p>
      {loading ? (
        <div className="w-100 d-flex justify-content-center py-5 my-5">
          <Loading size={30} />
        </div>
      ) : (
        <div className="mt-3 d-flex justify-content-between align-items-center">
          <CustomButton
            shadow={true}
            color={"primary"}
            clickHandler={confirmHandler}
            text={"تایید"}
            styles={{ width: "40%" }}
          />
          <CustomButton
            shadow={true}
            color={"secondary"}
            clickHandler={closeHandler}
            text={"لغو"}
            styles={{ width: "43%" }}
          />
        </div>
      )}
    </div>
  );
  return (
    <Modal
      open={show}
      closeHandler={closeHandler}
      dialogContent={content}
      inputDialog={true}
    />
  );
};

export default SubmitReserveModal;
